export default "__VITE_ASSET__CNQ$CO4q__"